// veh_type_group_order/VehTypeGroupOrderGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * VEH_TYPE_GROUP_ORDER Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-08-20 17:36:32 using DbdbTap
 ************************************************ */

const VEH_TYPE_GROUP_ORDER_LIST_PART = gql`
fragment VehTypeGroupOrderListPart on VehTypeGroupOrder {
    vehTypeId
    vehTypeGpCd
    vehOrder
    vehTypeName
    regDate
    regUser
    userName
    freshCargo
    loadCapa
    loadCapaText
    dcCd
}
`;


export const LIST_VEH_TYPE_GROUP_ORDER = gql`
${VEH_TYPE_GROUP_ORDER_LIST_PART}
query ListVehTypeGroupOrder($vehTypeGpCd:String!) {
    vehTypeGroupOrderList(vehTypeGpCd:$vehTypeGpCd) {
        ...VehTypeGroupOrderListPart
    }
}
`;

export const GET_VEH_TYPE_GROUP_ORDER = gql`
${VEH_TYPE_GROUP_ORDER_LIST_PART}
query GetVehTypeGroupOrder($vehTypeGpCd:String!, $vehTypeId:String!) {
    vehTypeGroupOrderItem(vehTypeGpCd:$vehTypeGpCd, vehTypeId:$vehTypeId) {
        ...VehTypeGroupOrderListPart
    }
}
`;

// vehTypeGroupOrderListAll: [VehTypeGroupOrder]!
/*
    그룹에 속하는 모든 차종 목록.
    주로 Select를 위해 사용한다.
    필요에 따라 Filtering해서 사용한다.
*/
export const LIST_VEH_TYPE_GROUP_ORDER_ALL = gql`
query ListVehTypeGroupOrderAll {
    vehTypeGroupOrderListAll {
        vehTypeId
        vehTypeName
        vehTypeGpCd
        vehOrder
        dcCd
        loadCapa
    }
}
`;

// vehTypeGroupOrderListByDc(dcCd:String!): [VehTypeGroupOrder]!
export const LIST_VEH_TYPE_GROUP_ORDER_BY_DC = gql`
query ListVehTypeGroupOrderByDc($dcCd:String!) {
    vehTypeGroupOrderListByDc(dcCd:$dcCd) {
        vehTypeId
        vehTypeName
        vehTypeGpCd
        vehOrder
        dcCd
        loadCapa
    }
}
`;

export const MAP_VEH_TYPE_GROUP_ORDER = gql`
mutation AddVehTypeGroupOrder($vehTypeGroupOrder:InputVehTypeGroupOrderMap!) {
	vehTypeGroupOrderMap(vehTypeGroupOrder: $vehTypeGroupOrder) {
		ok
		message
	}
}
`;


export const REMOVE_VEH_TYPE_GROUP_ORDER = gql`
mutation RemoveVehTypeGroupOrder($vehTypeGroupOrder:InputVehTypeGroupOrderRemove!) {
	vehTypeGroupOrderRemove(vehTypeGroupOrder: $vehTypeGroupOrder) {
		ok
		message
	}
}
`;

export function devideTypesByGroupCode(vehTypeGpCd, list) {
    const inGroupA = [];
    const outGroup = [];
    list.forEach(item => {
        if(item.vehTypeGpCd === vehTypeGpCd) inGroupA.push(item);
        else outGroup.push(item);
    });
    return {inGroup:inGroupA.sort((a,b) => a.vehOrder - b.vehOrder), outGroup};
}
